import { Country } from '@/common/types/work-info.def.ts'
import { stringArrayToSelectOptions } from '@/utils/misc.ts'

export const CommonStaffCost: string[] = [
  'Basic Salary',
  'Housing Allowance',
  'Sign-on Bonus',
  'Guaranteed Bonus',
  'Discretionary Bonus',
  'Retention Bonus',
  'Referral Bonus',
  'Additional Bonus',
  'Exceptional Achievement Reward',
  'NPL',
  'Medical/Life Insurance',
  'Medical Insurance Reimbursement',
  'Social Insurance',
  'Overtime',
  'Benefit',
  'Other',
]

export const HkStaffCost: string[] = [
  'Employer MPF Contribution - Mandatory',
  'Employer MPF Contribution - Voluntary',
]

export const TwStaffCost: string[] = [
  'Labor Insurance ER',
  'Labor Pension ER',
  'Health Insurance ER',
  'Supplementary Health Insurance ER',
  'Labor Insurance Adj. (ER)',
  'Labor Pension Adj. (ER)',
  'Health Insurance Adj. (ER)',
]

export const AusStaffCost: string[] = [
  'Payroll Tax',
]

export const CnStaffCost: string[] = [
  'Severance Payment',
  'Pension ER',
  'UI ER',
  'WRI ER',
  'MI ER',
  'Medical ER',
  'Housing ER',
  'Supplementary Housing ER',
  'CIIC Management Fee',
]

export const JpStaffCost: string[] = [
  'Transport',

]

export const SgStaffCost: string[] = [
  'Employer CPF',
  'Skills Development Fund',
  'Leaves Encashment',
  'Non-Complete',
  'Release of Salary Withheld',
  'Salary Withheld',
  'Separation Payment',
]

export const UsStaffCost: string[] = [
  'Social Security',
  'Medicare',
  'FED FUTA',
  'MCTMT',
  'SUI',
  'Medical ER',
  'Incorrect deduction on medical',
  'Service Fee (+ Employee Adjustments)',
  'Employer Adjustments',
]

export const StaffCostCountryMap: Record<string, string[]> = {
  [Country.HongKong]: [...CommonStaffCost, ...HkStaffCost],
  [Country.Taiwan]: [...CommonStaffCost, ...TwStaffCost],
  [Country.Australia]: [...CommonStaffCost, ...AusStaffCost],
  [Country.China]: [...CommonStaffCost, ...CnStaffCost],
  [Country.India]: [...CommonStaffCost],
  [Country.Japan]: [...CommonStaffCost, ...JpStaffCost],
  [Country.Singapore]: [...CommonStaffCost, ...SgStaffCost],
  [Country.Korea]: [...CommonStaffCost],
  [Country.UnitedKingdom]: [...CommonStaffCost],
  [Country.UnitedStates]: [...CommonStaffCost, ...UsStaffCost],
}

export const validateStaffCostName = (country: string, costName: string): boolean => {
  if (!StaffCostCountryMap[country]) return false

  return StaffCostCountryMap[country].includes(costName)
}

export const VendorCostReportType = {
  Payroll: 'Payroll',
  Insurance: 'Insurance',
}
export const VendorCostReportTypeOptions = stringArrayToSelectOptions(Object.values(VendorCostReportType))